export default "__VITE_ASSET__BWQaYJrf__"